import type { ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { TRACKER_INACTIVE_MESSAGE } from '../utils/trackerTariff';

interface TrackerInactiveStateProps {
  children: ReactNode;
}

const TrackerInactiveState = ({ children }: TrackerInactiveStateProps) => (
  <>
    <Alert variant="warning" className="my-2 fs--1">
      <div className="d-flex flex-column flex-md-row gap-2 justify-content-between align-items-start align-items-md-center">
        <p className="mb-0 text-justify pe-3 d-flex align-items-start gap-2">
          <FontAwesomeIcon icon="lock" className="mt-1 flex-shrink-0" />
          <span>{TRACKER_INACTIVE_MESSAGE}</span>
        </p>
        <Link
          to="/prorogate-or-upgrade/"
          className="text-decoration-none flex-shrink-0"
        >
          <Button variant="falcon-primary" size="sm">
            خرید افزونه ردیاب
          </Button>
        </Link>
      </div>
    </Alert>
    {children}
  </>
);

export default TrackerInactiveState;
